import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../sections/createSendProductReport/message/fieldDefinition";


import { FormlyView } from "../FormlyView";

export class XEVPRMMessage extends FormlyView
{

    constructor(
        form: FormGroup,
        fieldDefinition: FieldDefinition,
        model: {},
    ) {
        super(form, [...fieldDefinition.messageHeaderFields], model);
    }
    
}
